<template>
  <EwgDialog ref="Dialog" @close="close()" modal>
    <div class="store-dialog">
      <div class="header">
        <span>商店与角色背包</span>
        <span class="pointer" @click="close()">关闭</span>
      </div>
      <div class="content">
        <div class="store-content">
          <StoreBox></StoreBox>
        </div>
        <div class="tab-content">
          <TabBox></TabBox>
        </div>
      </div>
      <div class="footer"></div>
    </div>
  </EwgDialog>
</template>
<script lang="ts">
import { ref } from "vue";
import TabBox from "./TabBox.vue";
import StoreBox from "./StoreBox.vue";
export default {
  name: "StoreDialog",
  components: {
    TabBox,
    StoreBox
  },
  setup() {
    const Dialog = ref();
    const close = () => {
      Dialog.value.close();
    };
    const open = () => {
      Dialog.value.open();
    };
    return {
      Dialog,
      close,
      open
    };
  }
};
</script>

<style lang="scss" scoped>
.store-dialog {
  width: 530px;
  background: $--color-black-half-quarter;
  color: #eee;
  border: 3px solid $--color-white;
  padding: 20px;
  border-radius: $--border-radius;
  .header {
    display: flex;
    justify-content: space-between;
  }
  .content {
    display: grid;
    grid-template-columns: 160px 1fr;
    margin-top: 5px;
    border-top: 1px solid $--color-white;
    .tab-content {
      padding: 5px 0 5px 8px;
      position: relative;
    }
    .store-content {
      border-right: 1px solid $--color-white;
      padding: 5px 10px 0 0;
    }
  }
}
</style>
